import { render, staticRenderFns } from "./result.vue?vue&type=template&id=7354d2b5&scoped=true"
import script from "./result.vue?vue&type=script&lang=js"
export * from "./result.vue?vue&type=script&lang=js"
import style0 from "./result.vue?vue&type=style&index=0&id=7354d2b5&prod&lang=less&scoped=true"
import style1 from "./result.vue?vue&type=style&index=1&id=7354d2b5&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7354d2b5",
  null
  
)

export default component.exports